import { ProfileStatusFieldEnum } from "@edp-enums/profile-status-field.enum";

export class ProfileStatus {
    incomplete: Array<ProfileStatusFieldEnum>;
    percent: number;
    status: string;

    constructor(data?: ProfileStatus) {
        Object.assign(this, data);
    }
}
